import request from '@/utils/request';
import type {
  AlipayCategoryTreeResponse,
  Category,
  CategoryListResponse,
  CategoryQueryParams,
  CategoryTreeResponse,
  CreateCategoryCommand,
  UpdateCategoryCommand
} from '../types/category';
import type {JdCodeOption} from '../types/jd';

export const categoryService = {
  // 获取分类列表
  getCategoryList: (params: CategoryQueryParams) => {
    return request.get<CategoryListResponse>('/api/admin/product/category', { params });
  },

  // 获取分类树
  getCategoryTree: () => {
    return request.get<CategoryTreeResponse>('/api/admin/product/category/tree');
  },

  // 获取支付宝商品类目树。不传主体时查默认客户端。
  getAlipayCategoryTree: (alipaySubjectId?: number) => {
    return request.get<AlipayCategoryTreeResponse>('/api/admin/product/category/alipay/tree', {
      params: alipaySubjectId ? { alipaySubjectId } : {},
    });
  },

  getJdCategoryOptions: () => {
    return request.get<JdCodeOption[]>('/api/admin/jd-products/category-options');
  },

  // 创建分类
  createCategory: (data: CreateCategoryCommand) => {
    return request.post<Category>('/api/admin/product/category', data);
  },

  // 更新分类
  updateCategory: (data: UpdateCategoryCommand) => {
    return request.put<Category>(`/api/admin/product/category/${data.id}`, data);
  },

  // 删除分类
  deleteCategory: (id: number) => {
    return request.delete(`/api/admin/product/category/${id}`);
  },

  // 获取分类详情
  getCategoryDetail: (id: number) => {
    return request.get<Category>(`/api/admin/product/category/${id}`);
  },
};
